import React, { Component } from 'react'
import { Row, Col, Form, Card, Button } from "react-bootstrap";
import "./_DiaryModal.scss"
import gql from "graphql-tag";
import { graphql, withApollo } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import moment from "moment";
import { getAuthorizedSubjectIds, filterByAuthorizedIds } from "../../utils/authHelper";

// Stream applies only to Intermediate — Class 11 / Class 12, ids 1 & 2. It sits
// between Class and Section and narrows the section list by each section's stream_id.
// Previously [15, 16]: id 15 is Nursery and id 16 a disabled "Class 12" duplicate,
// so Nursery was treated as streamed and its NULL stream_id emptied the Section list.
const STREAM_CLASS_IDS = [1, 2];
const isStreamClass = (classId) => STREAM_CLASS_IDS.includes(parseInt(classId));

const ADD_DIARY_ASSIGNMENT_DETAILS = gql`
mutation($params:AddDairyAssignmentDetails){
    addDairyAssignmentDetails(params:$params)
}
`;

const GET_ACADEMIC_YEARS = gql`
    query getAcademicYears($id: Int) {
      getAcademicYears(id: $id) {
        id
        academic_year
      }
    }
  `;

const GET_CLASS_SUBJECTS_BY_ACADEMIC_YEAR = gql`
    query getClassSubjectsByAcademicYear(
        $academic_year_id: Int!
        $exam_standard_ids: String
        $classIds: String
        $institute_id: Int!
    ) {
        getClassSubjectsByAcademicYear(
            academic_year_id: $academic_year_id
            exam_standard_ids: $exam_standard_ids
            classIds: $classIds
            institute_id: $institute_id
        ) {
            class_id
            checked
            class_name
            subject_ids
            subject_names
        }
    }
`;

const GET_DIARY_DETAILS = gql`
  query($institute_id:Int,$branch_id:String,$dairy_assignment_type_id:Int,$from_date:String,$to_date:String){
    getStudentDairyAssignmentDetails(institute_id:$institute_id,branch_id:$branch_id,dairy_assignment_type_id:$dairy_assignment_type_id,from_date:$from_date,to_date:$to_date){
      dairy_assignment_creation_details {
        dairyAssigment_id title description file_path assignment_marks to_date from_date
        employee_id exam_id class_id subject_id section_ids Class Exam Section_Name subject_name
        branch_name
      }
    }
  }
`;

class AddDiary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            branch_id: "",
            branchError: "",
            class_id: "",
            classError: "",
            academic_year_id: "",
            academicYearError: "",
            stream_id: "",
            streamError: "",
            getStreams: [],
            section_id: "",
            sectionError: "",
            dynamicEditItems: null,
            toDate: new Date().toISOString().slice(0, 10),
            currentDate: new Date().toISOString().slice(0, 10),
            toDateError: "",
            loadingSpinner: 0,
            currentStep: 1,
            subject_id: "",
            subjectError: "",
            getClasses: [],
            getSections: [],
            getSubjects: [],
            defaultvalue: 0,
            ldescription: "",
            ldescription_error: "",
            loader: 0,
            dataClear: 0,
            submitError: "",
            submitted: false,
            file_upload: "",
            file_uploadError: "",
            isDisabled: false,
            dairyAssigment_id: null
        }
    }

    componentDidMount() {
        this.initializeData();
    }

    componentDidUpdate(prevProps) {
        // If editItems changes or we want to clear data on route change
        if (this.props.editItems !== prevProps.editItems) {
            this.initializeData();
        }

        // getStreams is fetched lazily (only once a stream class is picked), so the
        // response usually lands AFTER the class-change handler already stored the
        // section-derived fallback in state. Recompute the options when it arrives,
        // otherwise the full stream list wouldn't show until the class was re-selected.
        if (prevProps.streams !== this.props.streams && isStreamClass(this.state.class_id)) {
            this.setState({
                getStreams: this.getStreamOptions(this.state.branch_id, this.state.class_id),
            });
        }

        // If academic years query just finished loading, and we are in edit mode waiting for subjects
        if (prevProps.getAcademicYearsQuery && prevProps.getAcademicYearsQuery.loading && this.props.getAcademicYearsQuery && !this.props.getAcademicYearsQuery.loading) {
            if (this.state.class_id && this.state.getSubjects.length === 1 && this.state.getSubjects[0].value === 0) {
                this.fetchClassSubjects(this.state.class_id);
            }
        }
    }

    initializeData = () => {
        this.setState({
            branchError: "",
            classError: "",
            academicYearError: "",
            sectionError: "",
            subjectError: "",
            defaultvalue: 0,
            ldescription_error: "",
            currentStep: 1,
            loadingSpinner: 0,
            dataClear: 1,
            submitError: "",
            submitted: false,
            file_upload: "",
            file_uploadError: "",
            toDateError: "",
            selectedSubjects: {}
        })

        if (this.props.editItems && this.props.editItems.length > 0) {
            let firstExistingData = this.props.editItems[0];
            // Parent branch filter is now multi-select; infer the entry's branch from its section.
            const branches = this.props.branches || [];
            const firstSectionId = (firstExistingData.section_ids || "").split(",")[0];
            const inferredBranch = branches.find((b) => (b.sections || []).some((s) => String(s.id) === String(firstSectionId)));
            const branchDetails = inferredBranch ? inferredBranch.id : "";
            // For Intermediate classes, infer the stream from the edited section so
            // the section list (which is stream-narrowed) still contains it.
            const editClassId = firstExistingData.class_id;
            const editSectionObj = inferredBranch
                ? (inferredBranch.sections || []).find((s) => String(s.id) === String(firstSectionId))
                : null;
            const inferredStreamId = isStreamClass(editClassId) && editSectionObj ? editSectionObj.stream_id : "";

            this.setState({
                branch_id: branchDetails,
                class_id: editClassId,
                stream_id: inferredStreamId,
                section_id: firstExistingData.section_ids,
                academic_year_id: firstExistingData.academic_year_id || "",
                toDate: moment.unix(firstExistingData.from_date).format("YYYY-MM-DD"),
                currentDate: moment.unix(firstExistingData.from_date).format("YYYY-MM-DD"),
                getClasses: this.getClasses(branchDetails),
                getStreams: this.getStreamOptions(branchDetails, editClassId),
                getSections: this.getSections(branchDetails, editClassId, inferredStreamId),
                getSubjects: [{ value: 0, label: "General" }],
                isDisabled: false
            }, () => {
                // Editing an Intermediate diary — load getStreams so the pre-filled
                // Stream dropdown shows its real name.
                this.props.onNeedStreams && this.props.onNeedStreams(editClassId);
                this.fetchClassSubjects(firstExistingData.class_id);
            })
        } else {
            const defaultBranch = this.props.branches && this.props.branches.length > 0 ? this.props.branches[0].id : "";
            this.setState({
                branch_id: defaultBranch,
                class_id: "",
                stream_id: "",
                section_id: "",
                academic_year_id: "",
                toDate: new Date().toISOString().slice(0, 10),
                currentDate: new Date().toISOString().slice(0, 10),
                getClasses: defaultBranch ? this.getClasses(defaultBranch) : [],
                getStreams: [],
                getSections: [],
                getSubjects: [],
                isDisabled: false
            })
        }
    }

    // Branch/class/section come from the same services as the page filter:
    // getBranches → branches[].sections, getExamClasses → class labels, both
    // fetched once by the parent and passed down via stateData.
    getClasses = (branch_id) => {
        const branches = this.props.branches || [];
        const allClasses = this.props.allClasses || [];
        const branch = branches.find((b) => String(b.id) === String(branch_id));
        if (!branch) return [];
        const classIds = [...new Set((branch.sections || []).map((s) => Number(s.class_id)))];
        return classIds
            .map((cid) => allClasses.find((c) => Number(c.id) === cid))
            .filter(Boolean)
            .map((c) => ({ value: c.id, label: c.class }))
            .sort((a, b) => Number(a.value || 0) - Number(b.value || 0));
    }

    getSections = (branch_id, class_id, stream_id) => {
        const branches = this.props.branches || [];
        const branch = branches.find((b) => String(b.id) === String(branch_id));
        if (!branch) return [];
        return (branch.sections || [])
            .filter((s) => Number(s.class_id) === Number(class_id))
            .filter((s) => !isStreamClass(class_id) || String(s.stream_id) === String(stream_id))
            .map((s) => ({ value: s.id, label: s.section_name }));
    }

    // Stream options for a stream class. Empty for non-stream classes (the Stream
    // dropdown is hidden in that case).
    //
    // Sourced from the getStreams API so every configured stream is offered — deriving
    // them from the branch's existing sections showed only the streams that already had
    // a section, so an institute running MPC/BiPC/CEC/MEC saw a single entry. A stream
    // applies when its `classes` CSV covers this class; no mapping means it applies to
    // all stream classes. Falls back to the section-derived ids until streams load.
    getStreamOptions = (branch_id, class_id) => {
        if (!isStreamClass(class_id)) return [];
        const branches = this.props.branches || [];
        const allStreams = this.props.streams || [];
        const cid = String(class_id);

        const fromApi = allStreams
            .filter((st) => {
                const applies = String(st.classes || "").split(",").map((x) => x.trim()).filter(Boolean);
                return applies.length === 0 || applies.includes(cid);
            })
            .map((st) => ({ value: Number(st.id), label: st.stream }));
        if (fromApi.length) return fromApi;

        const branch = branches.find((b) => String(b.id) === String(branch_id));
        if (!branch) return [];
        const streamIds = [...new Set((branch.sections || [])
            .filter((s) => Number(s.class_id) === Number(class_id) && s.stream_id)
            .map((s) => Number(s.stream_id)))];
        return streamIds.map((id) => ({
            value: id,
            label: (allStreams.find((st) => Number(st.id) === Number(id))?.stream) || `Stream ${id}`,
        }));
    }

    fetchClassSubjects = async (class_id) => {
        if (!class_id) {
            this.setState({ getSubjects: [{ value: 0, label: "General" }] });
            return;
        }

        let academic_year_id = "";
        const yearsData = this.props.getAcademicYearsQuery && this.props.getAcademicYearsQuery.getAcademicYears;
        if (yearsData && yearsData.length > 0) {
            // GET_ACADEMIC_YEARS query doesn't return is_active flag in AddDiary.jsx, so we default to the first year in the list.
            academic_year_id = yearsData[0].id;
        }

        if (!academic_year_id) {
            console.warn("fetchClassSubjects: No academic year found.");
            this.setState({ getSubjects: [{ value: 0, label: "General" }] });
            return;
        }

        try {
            const res = await this.props.client.query({
                query: GET_CLASS_SUBJECTS_BY_ACADEMIC_YEAR,
                variables: {
                    academic_year_id: parseInt(academic_year_id, 10),
                    exam_standard_ids: null,
                    classIds: String(class_id),
                    institute_id: parseInt(Cookies.get("institutionid"), 10),
                },
                fetchPolicy: "no-cache",
            });

            const apiData = res?.data?.getClassSubjectsByAcademicYear || [];
            if (apiData.length > 0) {
                const parseCsv = (value = "") => String(value).split(",").map((item) => item.trim()).filter(Boolean);
                const isCheckedValue = (value) => {
                    if (value === true || value === 1) return true;
                    const normalized = String(value ?? "").trim().toLowerCase();
                    return normalized === "true" || normalized === "1";
                };

                const subjectIds = parseCsv(apiData[0].subject_ids);
                const subjectNames = parseCsv(apiData[0].subject_names);
                const checkedValues = parseCsv(apiData[0].checked);
                
                // Narrowed to the subjects this user is assigned (subject_ids cookie).
                // An empty assignment leaves the class's full subject list.
                const subjects = filterByAuthorizedIds(
                    subjectIds.map((id, index) => ({
                        value: parseInt(id, 10),
                        label: subjectNames[index] || id,
                        checked: checkedValues.length ? isCheckedValue(checkedValues[index]) : false,
                    })).filter(subject => subject.checked).map(subject => ({ value: subject.value, label: subject.label })),
                    getAuthorizedSubjectIds(),
                    "value"
                );

                // "General" is a sentinel (id 0), not a real subject — always available.
                subjects.push({ value: 0, label: "General" });

                const existingItems = this.state.dynamicEditItems || this.props.editItems || [];
                const isEdit = existingItems.length > 0;
                const newSelectedSubjects = {};

                subjects.forEach(sub => {
                    const existingDataForSub = existingItems.find(item => String(item.subject_id) === String(sub.value));

                    if (sub.value === 0) {
                        newSelectedSubjects[0] = { checked: false, description: "" };
                    } else if (isEdit) {
                        if (existingDataForSub) {
                            newSelectedSubjects[sub.value] = { 
                                checked: true, 
                                description: existingDataForSub.description || "",
                                dairyAssigment_id: existingDataForSub.dairyAssigment_id
                            };
                        } else {
                            newSelectedSubjects[sub.value] = { checked: false, description: "", error: "" };
                        }
                    } else {
                        newSelectedSubjects[sub.value] = { checked: false, description: "", error: "" };
                    }
                });

                const existingOthers = existingItems.find(item => String(item.subject_id) === "0");
                if (isEdit && existingOthers) {
                    newSelectedSubjects[0] = { 
                        checked: true, 
                        description: existingOthers.description || "",
                        dairyAssigment_id: existingOthers.dairyAssigment_id
                    };
                }

                this.setState({ getSubjects: subjects, selectedSubjects: newSelectedSubjects });
            } else {
                this.setState({ getSubjects: [{ value: 0, label: "General" }], selectedSubjects: {} });
            }
        } catch (err) {
            console.error("Error fetching class subjects:", err);
            this.setState({ getSubjects: [{ value: 0, label: "General" }], selectedSubjects: {} });
        }
    }

    handleSubjectToggle = (subjectId) => {
        this.setState(prevState => ({
            selectedSubjects: {
                ...prevState.selectedSubjects,
                [subjectId]: {
                    ...prevState.selectedSubjects[subjectId],
                    checked: !prevState.selectedSubjects[subjectId]?.checked
                }
            },
            submitError: ""
        }));
    }

    handleSubjectDescChange = (subjectId, value) => {
        const words = value.trim().split(/\s+/).filter(Boolean);
        let newValue = value;
        let errorMsg = "";

        if (words.length > 50) {
            newValue = words.slice(0, 50).join(" ");
            errorMsg = "Maximum 50 words allowed.";
        }

        this.setState(prevState => ({
            selectedSubjects: {
                ...prevState.selectedSubjects,
                [subjectId]: {
                    ...prevState.selectedSubjects[subjectId],
                    description: newValue,
                    error: errorMsg
                }
            },
            submitError: ""
        }));
    }

    handleInputChange = e => {
        const name = e.target.name;
        const value = e.target.value;

        if (name == "branch") {
            if (value != "0") {
                this.setState({
                    class_id: "", stream_id: "", section_id: "", branch_id: value,
                    branchError: "", academic_year_id: "", getClasses: this.getClasses(value),
                    getStreams: [], getSections: [], classError: "", streamError: "", sectionError: "", academicYearError: "", getSubjects: [{ value: 0, label: "General" }],
                })
            } else {
                this.setState({
                    class_id: "", stream_id: "", section_id: "", branch_id: "",
                    branchError: "", getClasses: [], getStreams: [], getSections: [],
                    classError: "", streamError: "", sectionError: "", academicYearError: "", getSubjects: [{ value: 0, label: "General" }],
                })
            }
        }

        if (name == "class") {
            if (value != "0") {
                // Stream classes load no sections until a stream is picked; other
                // classes load their sections immediately.
                this.setState({
                    class_id: value, stream_id: "", section_id: "", branchError: "",
                    getStreams: this.getStreamOptions(this.state.branch_id, value),
                    getSections: this.getSections(this.state.branch_id, value, ""),
                    classError: "", streamError: "", sectionError: "", getSubjects: [{ value: 0, label: "General" }],
                }, () => {
                    // Stream classes only: ask the parent to fetch getStreams so the
                    // dropdown shows real stream names instead of "Stream <id>".
                    this.props.onNeedStreams && this.props.onNeedStreams(value);
                    this.fetchClassSubjects(value);
                })
            } else {
                this.setState({
                    class_id: "", stream_id: "", section_id: "", branchError: "",
                    getStreams: [], getSections: [], classError: "", streamError: "", sectionError: "", getSubjects: [{ value: 0, label: "General" }],
                })
            }
        }

        if (name == "stream") {
            this.setState({
                stream_id: value, section_id: "",
                getSections: this.getSections(this.state.branch_id, this.state.class_id, value),
                streamError: "", sectionError: "",
            })
        }

        if (name == "academic_year") {
            if (value != "0") {
                this.setState({
                    academic_year_id: value,
                    academicYearError: ""
                })
            } else {
                this.setState({
                    academic_year_id: "",
                    academicYearError: ""
                })
            }
        }

        if (name == "subject") {
            if (value != "0") {
                this.setState({ subject_id: value, subjectError: "" })
            }
        }

        if (name == "section") {
            if (value != "0") {
                this.setState({
                    section_id: value, sectionError: "",
                    subjectError: ""
                }, () => this.checkExistingDiary())
            } else {
                this.setState({ section_id: "", sectionError: "", dynamicEditItems: null }, () => {
                    if (this.state.class_id) this.fetchClassSubjects(this.state.class_id);
                })
            }
        }
    };

    checkExistingDiary = async () => {
        const { branch_id, class_id, section_id, toDate } = this.state;
        if (!branch_id || !class_id || !section_id || !toDate) {
            this.setState({ dynamicEditItems: null });
            return;
        }

        const unixDate = moment(toDate, 'YYYY-MM-DD').unix().toString();

        try {
            const res = await this.props.client.query({
                query: GET_DIARY_DETAILS,
                variables: {
                    institute_id: parseInt(Cookies.get("institutionid"), 10),
                    branch_id: branch_id.toString(),
                    dairy_assignment_type_id: 1,
                    from_date: unixDate,
                    to_date: unixDate
                },
                fetchPolicy: "network-only"
            });

            const details = res?.data?.getStudentDairyAssignmentDetails || [];
            let data = [];
            details.forEach(node => {
                if (node.dairy_assignment_creation_details?.length) {
                    data.push(...node.dairy_assignment_creation_details);
                }
            });
            
            const existing = data.filter(d => {
                const itemClassIds = (d.class_id || "").toString().split(",");
                const itemSectionIds = (d.section_ids || "").toString().split(",");
                return itemClassIds.includes(String(class_id)) && itemSectionIds.includes(String(section_id));
            });

            if (existing.length > 0) {
                this.setState({ dynamicEditItems: existing }, () => {
                    this.fetchClassSubjects(class_id);
                });
            } else {
                this.setState({ dynamicEditItems: null }, () => {
                    this.fetchClassSubjects(class_id);
                });
            }
        } catch (err) {
            console.error("Error checking existing diary:", err);
            this.setState({ dynamicEditItems: null });
        }
    }

    selecthandleInputChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        if (name == "ldescription") this.setState({ ldescription_error: "" });
        if (name == "file_upload") this.setState({ file_uploadError: "" });
        this.setState({ [name]: value });
    }

    handleFormSubmit = async () => {
        if (this.state.branch_id === "" || this.state.branch_id === "--Select Branch--") {
            this.setState({ branchError: "Please select branch" });
            return;
        } else if (this.state.class_id === "" || this.state.class_id === "--Select Class--") {
            this.setState({ classError: "Please select class" });
            return;
        } else if (isStreamClass(this.state.class_id) && (this.state.stream_id === "" || this.state.stream_id === "--Select Stream--")) {
            this.setState({ streamError: "Please select stream" });
            return;
        } else if (this.state.section_id === "" || this.state.section_id === "--Select Section--") {
            this.setState({ sectionError: "Please select section" });
            return;
        } else if (this.state.toDate === "" || this.state.toDate === null) {
            this.setState({ toDateError: "Please Select Target Date" })
            return;
        }

        const selectedSubjectIds = Object.keys(this.state.selectedSubjects).filter(id => this.state.selectedSubjects[id].checked);
        const deletedSubjectIds = Object.keys(this.state.selectedSubjects).filter(id => !this.state.selectedSubjects[id].checked && this.state.selectedSubjects[id].dairyAssigment_id);
        
        if (selectedSubjectIds.length === 0 && deletedSubjectIds.length === 0) {
            this.setState({ submitError: "Please select at least one subject." });
            return;
        }

        let hasDescError = false;
        const updatedSubjects = { ...this.state.selectedSubjects };
        for (let id of selectedSubjectIds) {
            if (!updatedSubjects[id].description || updatedSubjects[id].description.trim() === "") {
                hasDescError = true;
                updatedSubjects[id] = { ...updatedSubjects[id], error: "Description is required." };
            }
        }
        if (hasDescError) {
            this.setState({ selectedSubjects: updatedSubjects, submitError: "Please provide a description for all selected subjects." });
            return;
        }

        this.setState({ loadingSpinner: 1, submitError: "" });

        try {
            const promises = [];

            selectedSubjectIds.forEach(subject_id => {
                const params = {
                    institute_id: parseInt(Cookies.get("institutionid")),
                    branch_id: parseInt(this.state.branch_id),
                    class_id: (this.state.class_id).toString(),
                    section_ids: this.state.section_id,
                    from_date: moment(this.state.toDate, 'YYYY-MM-DD').unix().toString(),
                    description: this.state.selectedSubjects[subject_id].description,
                    dairy_assignment_type_id: parseInt(1),
                    inserted_by: parseInt(Cookies.get("id")),
                    subject_id: parseInt(subject_id),
                    employee_id: 0,
                    estatus: 1
                };

                if (this.state.selectedSubjects[subject_id].dairyAssigment_id) {
                    params.dairy_assignment_id = parseInt(this.state.selectedSubjects[subject_id].dairyAssigment_id);
                }
                
                promises.push(this.props.addDairyAssignmentDetails({ variables: { params } }));
            });

            deletedSubjectIds.forEach(subject_id => {
                const params = {
                    institute_id: parseInt(Cookies.get("institutionid")),
                    branch_id: parseInt(this.state.branch_id),
                    class_id: (this.state.class_id).toString(),
                    section_ids: this.state.section_id,
                    from_date: moment(this.state.toDate, 'YYYY-MM-DD').unix().toString(),
                    description: "",
                    dairy_assignment_type_id: parseInt(1),
                    inserted_by: parseInt(Cookies.get("id")),
                    subject_id: parseInt(subject_id),
                    employee_id: 0,
                    dairy_assignment_id: parseInt(this.state.selectedSubjects[subject_id].dairyAssigment_id),
                    estatus: 0
                };
                
                promises.push(this.props.addDairyAssignmentDetails({ variables: { params } }));
            });

            await Promise.all(promises);

            this.setState({
                class_id: "",
                stream_id: "",
                section_id: "",
                academic_year_id: "",
                getClasses: this.state.branch_id ? this.getClasses(this.state.branch_id) : [],
                getStreams: [],
                getSections: [],
                getSubjects: [{ value: 0, label: "General" }],
                selectedSubjects: {},
                currentStep: 5,
                loadingSpinner: 0
            });

            if (this.props.onSubmitSuccess) {
                this.props.onSubmitSuccess();
            }

            // Show the success message briefly, then return to the registry. onCancel is
            // the parent's "back to registry" callback (it routes to
            // /student-diary/registry and clears editItems), so add and update both land
            // back on the list. Navigating from inside this timer — rather than a second
            // one in the parent — keeps the setState above ahead of the unmount.
            setTimeout(() => {
                this.setState({ currentStep: 1 });
                if (this.props.onCancel) this.props.onCancel();
            }, 1500);
            
        } catch (error) {
            console.error("Error creating diaries:", error);
            this.setState({ loadingSpinner: 0, submitError: "Failed to create diary entries. Please try again." });
        }
    }

    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "" });
        if(this.props.onCancel) {
            this.props.onCancel();
        }
    };

    selDate = (e) => {
        this.setState({ toDate: e.target.value }, () => {
            if (this.state.class_id && this.state.section_id) {
                this.checkExistingDiary();
            }
        })
    }

    render() {
        const isEdit = this.props.editItems && this.props.editItems.length > 0;

        return (
            <div className="add-diary-container p-4">
                <Card className="border-0 shadow-sm" style={{ borderRadius: '16px' }}>
                    <Card.Body className="p-4">
                        {/* ── Header ── */}
                        <div className="dm-modal-header mb-4" style={{borderBottom: '1px solid #e2e8f0', paddingBottom: '15px'}}>
                            <div className="dm-header-icon"><i className="fal fa-clipboard" /></div>
                            <div className="dm-header-info">
                                <h4 className="dm-title mb-1" style={{fontWeight: 700}}>{isEdit ? "Edit" : "Add"} Diary Entry</h4>
                                <p className="dm-subtitle text-muted mb-0">Fill in all required fields below</p>
                            </div>
                        </div>

                        {/* Date bar */}
                        <div className="dm-date-bar mb-4">
                            <span className="dm-date-label mr-3" style={{fontWeight: 600}}>
                                <i className="fas fa-calendar-alt text-primary mr-2" /> Diary Date
                            </span>
                            <input
                                type="date"
                                name="toDate"
                                className="form-control d-inline-block w-auto"
                                min={moment().subtract(3, 'days').format('YYYY-MM-DD')}
                                max={this.state.currentDate}
                                value={this.state.toDate}
                                onChange={this.selDate}
                                style={{borderRadius: '8px'}}
                            />
                        </div>

                        <Form>
                            <Form.Row>
                                {/* Branch */}
                                <Form.Group as={Col} lg={4} md={6} sm={12}>
                                    <div className="dm-field">
                                        <label className="dm-label" style={{fontWeight: 600}}>
                                            <i className="fas fa-code-branch text-primary mr-2" /> Branch
                                        </label>
                                        <select
                                            className={`dm-select form-control${this.state.branchError ? " is-err" : ""}`}
                                            name="branch"
                                            onChange={this.handleInputChange}
                                            value={this.state.branch_id}
                                            style={{borderRadius: '8px', padding: '10px'}}
                                        >
                                            <option value="">Select Branch</option>
                                            {(this.props.branches || []).map(b => (
                                                <option key={b.id} value={b.id}>{b.branch_name}</option>
                                            ))}
                                        </select>
                                        {this.state.branchError && (
                                            <div className="dm-field-err text-danger mt-1" style={{fontSize: '12px'}}>
                                                <i className="fas fa-exclamation-circle mr-1" />{this.state.branchError}
                                            </div>
                                        )}
                                    </div>
                                </Form.Group>

                                {/* Class */}
                                <Form.Group as={Col} lg={4} md={6} sm={12}>
                                    <div className="dm-field">
                                        <label className="dm-label" style={{fontWeight: 600}}>
                                            <i className="fas fa-chalkboard text-primary mr-2" /> Class
                                        </label>
                                        <select
                                            className={`dm-select form-control${this.state.classError ? " is-err" : ""}`}
                                            name="class"
                                            onChange={this.handleInputChange}
                                            value={this.state.class_id}
                                            style={{borderRadius: '8px', padding: '10px'}}
                                        >
                                            <option value="">Select Class</option>
                                            {this.state.getClasses.map(c => (
                                                <option key={c.value} value={c.value}>{c.label}</option>
                                            ))}
                                        </select>
                                        {this.state.classError && (
                                            <div className="dm-field-err text-danger mt-1" style={{fontSize: '12px'}}>
                                                <i className="fas fa-exclamation-circle mr-1" />{this.state.classError}
                                            </div>
                                        )}
                                    </div>
                                </Form.Group>

                                {/* Stream (Intermediate classes only) */}
                                {isStreamClass(this.state.class_id) && (
                                    <Form.Group as={Col} lg={4} md={6} sm={12}>
                                        <div className="dm-field">
                                            <label className="dm-label" style={{fontWeight: 600}}>
                                                <i className="fas fa-stream text-primary mr-2" /> Stream
                                            </label>
                                            <select
                                                className={`dm-select form-control${this.state.streamError ? " is-err" : ""}`}
                                                name="stream"
                                                onChange={this.handleInputChange}
                                                value={this.state.stream_id}
                                                style={{borderRadius: '8px', padding: '10px'}}
                                            >
                                                <option value="">Select Stream</option>
                                                {this.state.getStreams.map(st => (
                                                    <option key={st.value} value={st.value}>{st.label}</option>
                                                ))}
                                            </select>
                                            {this.state.streamError && (
                                                <div className="dm-field-err text-danger mt-1" style={{fontSize: '12px'}}>
                                                    <i className="fas fa-exclamation-circle mr-1" />{this.state.streamError}
                                                </div>
                                            )}
                                        </div>
                                    </Form.Group>
                                )}

                                {/* Section */}
                                <Form.Group as={Col} lg={4} md={6} sm={12}>
                                    <div className="dm-field">
                                        <label className="dm-label" style={{fontWeight: 600}}>
                                            <i className="fas fa-layer-group text-primary mr-2" /> Section
                                        </label>
                                        <select
                                            className={`dm-select form-control${this.state.sectionError ? " is-err" : ""}`}
                                            name="section"
                                            onChange={this.handleInputChange}
                                            value={this.state.section_id}
                                            disabled={isStreamClass(this.state.class_id) && !this.state.stream_id}
                                            style={{borderRadius: '8px', padding: '10px'}}
                                        >
                                            <option value="">Select Section</option>
                                            {this.state.getSections.map(s => (
                                                <option key={s.value} value={s.value}>{s.label}</option>
                                            ))}
                                        </select>
                                        {this.state.sectionError && (
                                            <div className="dm-field-err text-danger mt-1" style={{fontSize: '12px'}}>
                                                <i className="fas fa-exclamation-circle mr-1" />{this.state.sectionError}
                                            </div>
                                        )}
                                    </div>
                                </Form.Group>

                                {/* Subjects List */}
                                <Form.Group as={Col} sm={12}>
                                    <div className="dm-field mt-3">
                                        <label className="dm-label" style={{fontWeight: 600}}>
                                            <i className="fas fa-book-open text-primary mr-2" /> Select Subjects & Enter Descriptions
                                        </label>
                                        
                                        {this.state.getSubjects.length <= 1 ? (
                                            <div className="text-muted small p-3" style={{background: '#f8fafc', borderRadius: '8px'}}>
                                                Please select a class to load subjects.
                                            </div>
                                        ) : (
                                            <div style={{ paddingRight: '10px' }}>
                                                {this.state.getSubjects.map(sub => {
                                                    const isChecked = this.state.selectedSubjects[sub.value]?.checked || false;
                                                    const desc = this.state.selectedSubjects[sub.value]?.description || "";
                                                    
                                                    return (
                                                        <div key={sub.value} className="mb-3 p-3" style={{ border: isChecked ? '1px solid #8b5cf6' : '1px solid #e2e8f0', borderRadius: '8px', background: isChecked ? '#f5f3ff' : '#fff', transition: 'all 0.2s' }}>
                                                            <div className="custom-control custom-checkbox mb-2">
                                                                <input
                                                                    type="checkbox"
                                                                    className="custom-control-input"
                                                                    id={`subjectCheck_${sub.value}`}
                                                                    checked={isChecked}
                                                                    onChange={() => this.handleSubjectToggle(sub.value)}
                                                                    disabled={false}
                                                                />
                                                                <label className="custom-control-label font-weight-bold" htmlFor={`subjectCheck_${sub.value}`} style={{ cursor: 'pointer', color: isChecked ? '#6d28d9' : '#475569' }}>
                                                                    {sub.label}
                                                                </label>
                                                            </div>
                                                            
                                                            {isChecked && (
                                                                <>
                                                                    <textarea
                                                                        className={`dm-textarea form-control mt-2 ${this.state.selectedSubjects[sub.value]?.error ? "is-err" : ""}`}
                                                                        placeholder={`Enter diary description for ${sub.label}...`}
                                                                        value={desc}
                                                                        onChange={(e) => this.handleSubjectDescChange(sub.value, e.target.value)}
                                                                        style={{ borderRadius: '8px', minHeight: '80px', border: this.state.selectedSubjects[sub.value]?.error ? '1px solid #dc3545' : '1px solid #cbd5e1' }}
                                                                    />
                                                                    {this.state.selectedSubjects[sub.value]?.error && (
                                                                        <div className="text-danger small mt-1" style={{fontWeight: 600}}>
                                                                            <i className="fas fa-exclamation-circle mr-1" /> {this.state.selectedSubjects[sub.value].error}
                                                                        </div>
                                                                    )}
                                                                </>
                                                            )}
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        )}
                                    </div>
                                </Form.Group>
                            </Form.Row>

                            {/* Feedback banners */}
                            {this.state.currentStep == 5 && (
                                <div className="alert alert-success mt-3" style={{borderRadius: '8px'}}>
                                    <i className="fas fa-check-circle mr-2" />
                                    Diary entry saved successfully!
                                </div>
                            )}
                            {this.state.submitError && this.state.currentStep != 5 && (
                                <div className="alert alert-danger mt-3" style={{borderRadius: '8px'}}>
                                    <i className="fas fa-times-circle mr-2" />
                                    {this.state.submitError}
                                </div>
                            )}
                        </Form>

                        {/* ── Footer ── */}
                        <div className="dm-footer d-flex justify-content-end mt-4 pt-3" style={{borderTop: '1px solid #e2e8f0'}}>
                            <Button 
                                variant="light" 
                                className="mr-2" 
                                onClick={this.SetpageLoad}
                                style={{borderRadius: '8px', fontWeight: 600, color: '#475569'}}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="primary"
                                onClick={this.handleFormSubmit}
                                disabled={this.state.loadingSpinner == 1 || this.state.currentStep == 5}
                                style={{
                                    borderRadius: '8px', 
                                    fontWeight: 600, 
                                    background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
                                    border: 'none'
                                }}
                            >
                                {this.state.loadingSpinner == 1 && (
                                    <span className="spinner-border spinner-border-sm mr-2" />
                                )}
                                {isEdit ? "Update Entry" : "Submit Entry"}
                            </Button>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        )
    }
}

export default withRouter(compose(
    withApollo,
    graphql(ADD_DIARY_ASSIGNMENT_DETAILS, {
        name: "addDairyAssignmentDetails"
    }),

    graphql(GET_ACADEMIC_YEARS, {
        name: "getAcademicYearsQuery",
        options: {
            variables: { id: 1 },
        },
        fetchPolicy: "network-only"
    })
)(AddDiary));
